<div class="level">
  <div class="level-item level-left">
    <h3 class="subtitle is-4 is-spaced">
      <button
        *ngIf="!hideFilterButton"
        class="button is-small is-pale-gray"
        (click)="onFilterButtonClick($event)"
      >
        <span class="icon is-small">
          <i class="material-icons md-24">tune</i>
        </span>
      </button>
      {{ title }}
    </h3>
  </div>
  <p class="level-item level-right">
    <ng-content></ng-content>
  </p>
</div>
